'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../adapter/index.js');

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class Offers {
  get(lang, slug) {
    return __async(this, null, function* () {
      const params = { slug, lang };
      const offer = yield index.adapter.offers.get(params);
      if (!offer || offer.length === 0) {
        throw new Error("Offer not found");
      }
      return offer[0];
    });
  }
  getAll(lang) {
    const params = { lang };
    return index.adapter.offers.getAll(params);
  }
  optIn(slug, lang, cta, userName) {
    const params = { slug, lang, cta, userName };
    return index.adapter.offers.optIn(params);
  }
}
const offers = new Offers();

exports.offers = offers;
